import BasePaperMenu from 'ember-paper/components/paper-menu/component';
import PaperMenuTrigger from 'ember-paper/components/paper-menu/trigger/component';
import PaperMenuContent from 'ember-paper/components/paper-menu/content/component';

class PaperMenu extends BasePaperMenu {
  // Passed to paper-menu as component classes rather than strings: a string
  // here reaches `ensureSafeComponent` and trips
  // `ensure-safe-component.string`.
  triggerComponent = PaperMenuTrigger;
  contentComponent = PaperMenuContent;
}

export default PaperMenu;
